import { Button, Col, Drawer, Form, notification, Row, Card } from 'antd'
import moment from 'moment/moment'
import React from 'react'
import { connect } from 'react-redux'
import GetEachFormFields from '../../components/_utils/appFormUtils'
import { formItemLayout } from '../../components/_utils/appUtils'
import { addAbstractNoteFxn } from './actions'

@Form.create()
class AbstractNotesDrawer extends React.Component {
  handleSubmit = e => {
    const { form, abstractId, onClose } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstractId
        valData.time = moment().format('lll')

        let resp = await addAbstractNoteFxn(valData)

        if (resp && resp.success) {
          notification.success({
            message: resp.message || 'Note added successfully'
          })
          form.resetFields()
          // Note: If you want the list to update, ensure the parent
          // triggers a reload or you handle the local state update here.
          onClose()
        }
      } else {
        notification.error({
          message: 'Please enter all required fields.'
        })
      }
    })
  }

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      onClose,
      notes = []
    } = this.props

    let inputSchema = [
      {
        label: 'Add Note',
        key: 'note',
        required: true,
        type: 'textArea',
        placeholder: 'Add Note'
      }
    ]

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        width={'70%'}
        title={'Notes'}>
        {/* Wrapping in Card bordered={false} to match the reference UI */}
        <Card bordered={false}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              {inputSchema.map((item, key) => (
                <Col span={24} key={key}>
                  <GetEachFormFields
                    item={item}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout}
                  />
                </Col>
              ))}
              <Col span={24}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Col>

              {/* Rendering list with the exact class names used in your reference component */}
              <Col span={24}>
                {notes && notes.map((item, i) => (
                  <div key={i} className="custom_card mb10">
                    <Card
                      bordered={true}
                      title={`${item.addedBy || 'User'}`}
                      extra={
                        <>
                          {moment(item.time).format('DD.MM.YYYY,h:mm A')}
                        </>
                      }>
                      {item.note}
                    </Card>
                  </div>
                ))}
              </Col>
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}

export default connect(null)(AbstractNotesDrawer)
